import { DecimalPipe, Location } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forEach } from 'jszip';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { GenAiMainService } from 'src/app/views/GenAI-POC/gen-ai-main.service';
import { AddProposalService } from 'src/app/views/proposals/add-proposal/add-proposal.service';

@Component({
  selector: 'app-create-nedit-poc',
  templateUrl: './create-nedit-poc.component.html',
  styleUrls: ['./create-nedit-poc.component.css'],
  providers:[DecimalPipe]
})
export class CreateNEditPocComponent {
public action:string='';
formData:FormGroup;
isTouched = {
  'ServiceLine': false,
  'TechStack': false,
  'ServiceOffering': false,
  'Logo':false
}
invalid: boolean = false;
logo: any;
// mailProofFilesLogo: any;
loading:boolean=false;
userEmail:string="";
allowedLogoExtentions: string = '.png,.jpeg,.jpg';
// allowedFileExtentions: string = '.docx,.pdf';
serviceLinesForDropDown:any[]=[];
serviceLinesForDropDown2:any[]=[];
serviceOfferingForDropDown:any[]=[];
techStackForDropDown:any[]=[];
serviceOfferingForDropDown2:any[]=[];
techStackForDropDown2:any[]=[];
selectedServiceLines:string[]=[];
selectedServiceOffering:string[]=[];
selectedTechStack:string[]=[];
  serveId: any[];
  compId: any[];
  serviceofferids: any[];
  serviceLinesValues: any;
  editPocId:number;
ownerEmailsDropdown:User[] = [];
pocEmailDropdown: User[] = [];
ownerErrorMessage: string = '';
pointOfContactErrorMessage: string ='';
  isFileUploaded: boolean = false;
  public selectedFiles: any = [];
  // hasApproval: boolean = false;
  selectedFileNames: any;
  attachmentsValidation: any;
  public fileTypeSelected: any = [];

public constructor(@Inject(MAT_DIALOG_DATA) public data: any,private toaster: ToastrService,private cdr: ChangeDetectorRef,
    private _authservice: AuthServiceService, private location: Location, private _service: GenAiMainService,
    private _propService: AddProposalService, public _dialog: MatDialog,
    public dialogRef: MatDialogRef<CreateNEditPocComponent>, public decimalPipe: DecimalPipe) {
    this.action = data.action;
  }
  async ngOnInit() {
    this.formData = new FormGroup({
      hasApproval: new FormControl(false, [Validators.required]),
      title: new FormControl('', [Validators.required]),
      url: new FormControl('', [Validators.required]),
      owner: new FormControl('', [Validators.required]),
      pointOfContact: new FormControl('', [Validators.required]),
      sourceCodeUrl: new FormControl([], [Validators.required]),
      techStack: new FormControl([], [Validators.required]),
      serviceLine: new FormControl([], [Validators.required]),
      serviceOffering: new FormControl([], [Validators.required]),
      files: new FormControl('', [Validators.required]),
      metaData: new FormControl('', [Validators.required, Validators.pattern(/.*\S.*/)]),
      mailProoffile: new FormControl('', [Validators.required]),
      readMeUrl: new FormControl('', [Validators.required]),
      demoUrl: new FormControl('', [Validators.required]),

    });

   this.userEmail=this._authservice.getEmailId(); 
   await this.getServiceLinesForDropDown(1);
    var payload={ competencyId:null, subCompetencyIds: [] };  
   await this.getTechStack(payload);

    if (this.action.toLowerCase() == "edit") {
      this.setFormData(this.data.editData);
    }
    this.formData.get('hasApproval')?.valueChanges.subscribe((value: boolean) => {
      if (value) {
        this.formData.enable({ emitEvent: false });
      } else {
        Object.keys(this.formData.controls).forEach(controlName => {
          if (controlName !== 'hasApproval') {
            this.formData.get(controlName)?.disable({ emitEvent: false });
          }
        });
      }
    });
  }

get title() {
  return this.formData.get('title')
}

get url() {
  return this.formData.get('url');
}
get owner() {
  return this.formData.get('owner');
}
get pointOfContact() {
  return this.formData.get('pointOfContact');
}
get sourceCodeUrl() {
  return this.formData.get('sourceCodeUrl');
}
get serviceLine() {
  return this.formData.get('serviceLine')
}

get serviceOfferings() {
  return this.formData.get('serviceOffering');
}
get metaData() {
  return this.formData.get('metaData');
}
get techStackControl() {
  return this.formData.get('techStack');
}
get files()
{
  return this.formData.get('files');
}
  get mailProoffile() {
    return this.formData.get('mailProoffile');
  }
  get readMeUrl() {
    return this.formData.get('readMeUrl');
  }

  get demoUrl() {
    return this.formData.get('demoUrl');
  }

  get hasApproval() {
    return this.formData.get('hasApproval')?.value;
  }

async onFileChange(file: FileList) {
  this.logo = { fileName: file.item(0).name,fileSize: file.item(0).size};
  let processedFile = await Promise.resolve(this.getImageData(file[0]));
  this.logo.base64 = processedFile.toString().split(",")[1];
}

getImageData(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  })
}

RemoveLogo()
{
  //this.logo = { ...this.logo }; // Break reference
  this.logo = null;
  this.formData.get('files')?.setValue(null);
  this.formData.get('files')?.markAsTouched();
  this.formData.get('files')?.setErrors({ required: true });
}

  // RemoveMailProof() {
  //   //this.logo = { ...this.logo }; // Break reference
  //   this.mailProofFilesLogo = null;
  //   this.formData.get('mailProoffile')?.setValue(null);
  //   this.formData.get('mailProoffile')?.markAsTouched();
  //   this.formData.get('mailProoffile')?.setErrors({ required: true });
  // }

getFilteredEmails(query: string, field: 'pocEmailDropdown' | 'ownerEmailsDropdown') {
  if (query.length >= 4) {
    this._propService.fetchEmployees(query).subscribe((emails) => {
      this[field] = emails.data;
    });
  } else {
    this[field] = [];
  }
}

validateEmail(field: 'owner' | 'pointOfContact', dropdown: any[]) {
  const enteredEmail = this[field].value;
  const emailExists = dropdown.some(user => user.userEmail === enteredEmail);

  if (!enteredEmail) {
    this[`${field}ErrorMessage`] = `${field === 'owner' ? 'Owner' : 'Point of Contact'} is required`;
    this[field].setErrors({ required: true });
  } else if (!emailExists) {
    this[`${field}ErrorMessage`] = `Please select a valid email from the dropdown.`;
    this[field].setErrors({ invalidEmail: true });
  } else {
    this[`${field}ErrorMessage`] = '';
    this[field].setErrors(null);
  }
}


setFormData(data)
{
    var index = data?.logoName?.indexOf('_');
    // var mailProofs = data?.mailProofName?.indexOf('_');
    var editLogoName = index >= 0 ? data.logoName?.substring(index + 1) : data?.logoName;
    // var editMailProofFiles = mailProofs >= 0 ? data.mailProofName?.substring(mailProofs + 1) : data?.mailProofName;
    this.editPocId = data.id;
    this.formData.controls['hasApproval'].setValue(data.hasApproval);
    this.formData.controls['title'].setValue(data.title);
    this.formData.controls['url'].setValue(data.url);
    this.formData.controls['owner'].setValue(data.owner);
    this.getFilteredEmails(data.owner, "ownerEmailsDropdown");
    this.formData.controls['pointOfContact'].setValue(data.pointofcontact);
    this.getFilteredEmails(data.pointofcontact, 'pocEmailDropdown')
    this.formData.controls['sourceCodeUrl'].setValue(data.sourceCodePathUrl);
    this.formData.controls['metaData'].setValue(data.metadata);
    this.formData.controls['readMeUrl'].setValue(data.readMeUrl);
    this.formData.controls['demoUrl'].setValue(data.demoUrl);
    this.formData.controls['mailProoffile'].setValue(data.mailProofUrl);
    this.logo = { fileName: editLogoName, fileSize: data.logoSize };
    if (this.logo?.fileName) {
      this.formData.controls['files'].clearValidators()
      this.formData.controls['files'].updateValueAndValidity()
    }
    for (let i = 0; i < data.techStack.length; i++) {

    var setTechstackValue = this.techStackForDropDown.filter(obj => obj.name.toLowerCase() == data.techStack[i].toLowerCase()).map(obj => obj);
    this.techStackForDropDown2 = this.techStackForDropDown2.concat(setTechstackValue);
    this.selectedTechStack=this.techStackForDropDown2.map(x=>x.name)
    this.formData.controls['techStack'].setValue(this.selectedTechStack);

  }
  
  for (let i = 0; i < data.serviceLine.length; i++) {

    var setServiceLineValue = this.serviceLinesForDropDown.filter(obj => obj.name.toLowerCase() == data.serviceLine[i].toLowerCase()).map(obj => obj);
    this.serviceLinesForDropDown2 = this.serviceLinesForDropDown2.concat(setServiceLineValue);

  }

  this.getServiceLinesForDropDownvalues(this.serviceLinesForDropDown2)

  for (let i = 0; i < data.serviceOffering.length; i++) {
    var setServiceLineValue = this.serviceOfferingForDropDown.filter(obj => obj.name.toLowerCase() == data.serviceOffering[i].toLowerCase()).map(obj => obj);
    this.serviceOfferingForDropDown2 = this.serviceOfferingForDropDown2.concat(setServiceLineValue);
    this.selectedServiceOffering=this.serviceOfferingForDropDown2.map(x=>x.name);
    this.formData.controls['serviceOffering'].setValue(this.selectedServiceOffering);
  }

    this.isTouched.TechStack = true;
    this.isTouched.ServiceOffering = true;

    // this.mailProofFilesLogo = { fileName: editMailProofFiles, fileSize: data.mailProofSize };
    // if (this.mailProofFilesLogo?.fileName) {
    //   this.formData.controls['mailProoffile'].clearValidators();
    //   // this.formData.controls['mailProoffile'].setValue(this.mailProofFilesLogo.fileName);
    //   this.formData.controls['mailProoffile'].updateValueAndValidity();
    // }
  }

  async saveData(event) {
    const isValid = !this.formData.invalid && this.logo != null && this.validateform();
    this.validateEmail('owner', this.ownerEmailsDropdown);
    this.validateEmail('pointOfContact', this.pocEmailDropdown);
    if (!isValid) {
      this.formData.markAllAsTouched();
      return;
    }
    this.loading = true
    let _formValue = this.formData.value
    let requestData = {
      hasApproval: _formValue.hasApproval,
      title: _formValue.title,
      url: _formValue.url,
      metadata: _formValue.metaData,
      sourceCodePath: _formValue.sourceCodeUrl,
      owner: _formValue.owner,
      pointofcontact: _formValue.pointOfContact,
      logoBase64: this.logo.base64,
      logoName: this.logo.fileName,
      logoSize: this.logo.fileSize,
      serviceLine: _formValue.serviceLine,
      serviceOffering: _formValue.serviceOffering,
      techStack: _formValue.techStack,
      DemoUrl: _formValue.demoUrl,
      ReadMeUrl: _formValue.readMeUrl,
      MailProofUrl : _formValue.mailProoffile
      // mailProofBase64: this.mailProofFilesLogo.base64,
      // mailProofName: this.mailProofFilesLogo.fileName,
      // mailProofSize: this.mailProofFilesLogo.fileSize
    }
    if (this.action.toLowerCase() == 'edit') {
      requestData['Id'] = this.editPocId
      requestData['UpdatedBy'] = this.userEmail.split('@')[0].split('.').join(' ');
      requestData['UpdatedOn'] = new Date();
      requestData['LastActivityOn'] = new Date();

      this.loading = true;
      this._service.EditPoc(requestData).subscribe((res) => {
            if(res.succeeded){
              this.toaster.success("Proof of Concept Updated Successfully");
              this.dialogRef.close(true);
            }
            else {
              this.loading = false;
              this.toaster.error("Error in Updating the POC. Please try again..");
            }
      });
    }
    else {
      requestData['CreatedBy'] = this.userEmail.split('@')[0].split('.').join(' ');
      requestData['CreatedOn'] = new Date();
      requestData['LastActivityOn'] = new Date();

      this.loading = true;
      this._service.AddPoc(requestData).subscribe((res) => {
            if(res.succeeded){
              this.toaster.success("Details Saved Successfully");
              this.dialogRef.close(true);
            }
            else {
              this.loading = false;
              this.toaster.error("Error in uploading the POC. Please try again..");
            }
      });
    }
}
autoCompleteFieldsInValid() {
  return this.selectedServiceLines.length==0 && this.selectedServiceOffering.length==0 && this.selectedTechStack.length==0;
}

validateform() {
  var validateData = false;
  for (const control of Object.keys(this.formData.controls)) {
    if (this.formData.controls[control].status == "INVALID") {
      validateData = true;
    }
  }
  if (validateData || this.autoCompleteFieldsInValid()) {
    for (const control of Object.keys(this.formData.controls)) {
      this.formData.controls[control].markAsTouched();
    }
    for (const control of Object.keys(this.isTouched)) {
      this.isTouched[control] = true;
    }
    return false;
  }
  return true;
}

async getTechStack(payload:any) : Promise<any[]>
{
  this.loading=true
  return await new Promise<any[]>((resolve, reject) => {this._service.GetAllTechStack().subscribe(res=>{
    res.data.forEach(x=>{
      if(x.name.startsWith('\t'))
      {
        x.name.replace('\t','')
      }
      if(!this.techStackForDropDown.map(x=>x.name).includes(x.name))
      {
        this.techStackForDropDown.push(x);
      }

      resolve(this.techStackForDropDown);
    })
  })
})
}

async getServiceLinesForDropDown(id: any): Promise<any[]> {
  this.loading = true;
  return await new Promise<any[]>((resolve, reject) => {
    this._propService.getServiceAreas().subscribe(x => {
      x.data.forEach(tech => {
        x = this.serviceLinesForDropDown.some(x => x.name == tech.name);
        if (!x) {
          this.serviceLinesForDropDown.push(tech);
          let serviceLines = this.serviceLinesForDropDown;
          this.serviceLinesForDropDown = Object.assign(serviceLines);
        }
        resolve(this.serviceLinesForDropDown)
      });

    });
  });
  this.loading = false;
}

getServiceLinesForDropDownvalues(event: any) {
  var serviceLinesForDropDown2 = event
  this.isTouched.ServiceLine = true;
  this.selectedServiceLines = event.map(item => item.name);
  this.formData.controls['serviceLine'].setValue(this.selectedServiceLines);
  this.serveId = [];
  this.compId = [];
  this.serviceofferids = [];


  //To remove Service offering values

  serviceLinesForDropDown2.forEach(y => {
    this.serviceofferids.push(y.id)
  })

  this.serviceOfferingForDropDown.forEach(areas => {
    if (!this.serviceofferids.includes(areas.serviceId)) {
      this.serviceOfferingForDropDown = this.serviceOfferingForDropDown.filter(item => item != areas);
    }
  });

  // To remove Competency values
  serviceLinesForDropDown2.forEach(element => {
    this.serveId.push(element.id)
    this.compId.push(element.competencyId)

  })

  const counts = this.compId.reduce((acc, currentValue) => {
    acc[currentValue] = (acc[currentValue] || 0) + 1;
    return acc;
  }, {});
  const distinctSet = new Set(this.compId);
  const distinctValues = Array.from(distinctSet);

  const inputStrings = event.map((x: any) => { return { serviceAreaInfo: x.serviceAreaInfo, serviceId: x.id } });
  const inputStringsDescription = event.map((x: any) => x.serviceAreaInfoDescription != null ? x.serviceAreaInfoDescription : x.serviceAreaInfo);//time > 12 ? 'PM' : 'AM' ;
  const listStartRegex = /\b1\./; // Regex to match '1.' as a word boundary
  const items = inputStrings?.map(inputString => {
    const match = inputString.serviceAreaInfo?.match(/<p>([\s\S]*?)<\/p>/);
    if (match) {
      const startIndex = match[1].search(listStartRegex);
      if (startIndex !== -1) {
        const content = match[1].substring(startIndex); // Extract substring from '1.' onwards
        return {
          serviceId: inputString.serviceId,
          serviceOfferings: content.split('<br/>').map(item => item.trim().replace(/^\d+\./, ''))
        }; // Split by '<br/>' and trim each item, removing the number at the beginning
      }
    }
    return [];
  });

  const itemsTooltip = inputStringsDescription.map(inputString => {
    const match = inputString?.match(/<p>([\s\S]*?)<\/p>/);
    if (match) {
      const startIndex = match[1].search(listStartRegex);
      if (startIndex !== -1) {
        const content = match[1].substring(startIndex); // Extract substring from '1.' onwards
        return content.split('<br/>').map(item => item.trim().replace(/^\d+\./, '')); // Split by '<br/>' and trim each item, removing the number at the beginning
      }
    }
    return [];
  });
  const flattenedItems = items.flat();
  const flattenedItemsTooltip = itemsTooltip.flat();
  let tooltipIndex = -1;
  let serviceOfferings = flattenedItems.map((item, index) => {
    return item.serviceOfferings.map(x => {
      tooltipIndex++;
      return {
        serviceId: item.serviceId,
        name: x,
        description: flattenedItemsTooltip[tooltipIndex] ?? []
      }
    })
  }
  );
  this.serviceOfferingForDropDown = serviceOfferings.flatMap((innerArray) => innerArray);
// if (!(event && event.length > 0)) 
// {
//   this.selectedServiceLines=[];
//   this.serviceOfferingForDropDown=[];
// }
  this.selectedServiceOffering = this.selectedServiceOffering.filter(offering =>
    this.serviceOfferingForDropDown.some(validOffering => validOffering.name === offering)
  );
  this.serviceOfferingForDropDown2 = this.serviceOfferingForDropDown2.filter(offering =>
    this.serviceOfferingForDropDown.some(validOffering => validOffering.name === offering.name)
  );
}
getServiceOfferingForDropDownvalues(event:any){
  this.selectedServiceOffering=event.map(x=>x.name);
  this.isTouched.ServiceOffering=true;
  this.formData.controls['serviceOffering'].setValue(this.selectedServiceOffering);
}
getTechStackValues(event:any)
{
  this.selectedTechStack=event.map(x=>x.name);
  this.isTouched.TechStack=true;
  this.formData.controls['techStack'].setValue(this.selectedTechStack);
}
getFileSize(fileLength):string{
  var sizeinKbStr=this.decimalPipe.transform((fileLength/1024),'1.2-2');
  var sizeinKb=parseFloat(sizeinKbStr.replace(/,/g, ''));
  if(sizeinKb>100)
  {
    var sizeinMbStr=this.decimalPipe.transform((sizeinKb/1024),'1.2-2');
    var sizeinMb=parseFloat(sizeinMbStr.replace(/,/g, ''));
    if(sizeinMb>50)
    {
      var sizeinGbStr=this.decimalPipe.transform((sizeinMb/1024),'1.2-2');
      var sizeinGb=parseFloat(sizeinGbStr.replace(/,/g, ''));
      return `${sizeinGb} GB`
    }
    else{
      return `${sizeinMb} MB`
    }
  }
  else{
    return `${sizeinKb} KB`
  }
}
  // async onMailProofFileChange(file: FileList) {
  //   if (file.length > 0) {
  //     this.mailProofFilesLogo = {
  //       fileName: file.item(0).name,
  //       fileSize: file.item(0).size
  //     };
  //     let processedFile = await this.getImageData(file[0]);
  //     this.mailProofFilesLogo.base64 = processedFile.toString().split(",")[1];
  //   }
  // }
}

export interface User {
  userId: number;
  userName: string;
  userEmail: string;
}